<template>
  <div>
    <Manpowermenubar_govem />

    <v-container fluid class="pa-6">
      <!-- Header Section -->
      <div class="mb-8">
        <h1 class="text-h4 font-weight-bold mb-2">
          <v-icon class="mr-2" color="primary">mdi-file-check</v-icon>
          ระบบจัดการรายงานพนักงานราชการและสถิติการเบิกจ่ายงบประมาณ พ.ศ. {{ period_college.period_college_year }} งวด {{ period_college.period_college_times }}
        </h1>
        <p class="text-subtitle1 text-grey">
          ตรวจสอบ อนุมัติรายงาน และวิเคราะห์สถิติการเบิกจ่ายงบประมาณ
        </p>
      </div>

      <!-- Main Tabs -->
      <v-tabs v-model="mainTab" background-color="transparent" color="primary">
        <!-- Tab 1: Approval Management -->
        <v-tab>
          <v-icon small class="mr-2">mdi-check-circle-outline</v-icon>
          ตรวจสอบและอนุมัติรายงาน
        </v-tab>

        <!-- Tab 2: Budget Statistics -->
        <v-tab>
          <v-icon small class="mr-2">mdi-chart-line</v-icon>
          สถิติการเบิกจ่ายงบประมาณ
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="mainTab">
        <!-- ======================== TAB 1: APPROVAL MANAGEMENT ======================== -->
        <v-tab-item>
          <!-- Filter Section -->
          <v-card class="mb-6 elevation-2 mt-4" style="border-radius: 12px">
            <v-card-text class="pa-6">
              <h3 class="text-h6 font-weight-bold mb-4">
                <v-icon small class="mr-2">mdi-filter-variant</v-icon>
                ตัวกรองข้อมูล
              </h3>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="filters.report_year"
                    :items="yearOptions"
                    label="ปีการศึกษา"
                    outlined
                    dense
                    rounded
                    @change="loadApprovalData"
                    prepend-icon="mdi-calendar"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="filters.report_time"
                    :items="timeOptions"
                    label="ครั้งที่"
                    outlined
                    dense
                    rounded
                    @change="loadApprovalData"
                    prepend-icon="mdi-clock-outline"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="filters.status"
                    :items="statusOptions"
                    label="สถานะ"
                    outlined
                    dense
                    rounded
                    clearable
                    @change="loadApprovalData"
                    prepend-icon="mdi-checkmark-circle-outline"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn
                    color="primary"
                    block
                    rounded
                    @click="loadApprovalData"
                    :loading="isLoading"
                    height="40"
                    class="font-weight-bold"
                  >
                    <v-icon small class="mr-1">mdi-refresh</v-icon>
                    ค้นหา
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Summary Cards -->
          <v-row class="mb-8">
            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-blue" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="primary" class="mb-2">mdi-file-document-multiple</v-icon>
                  <div class="text-h4 font-weight-bold text-primary mb-2">{{ summaryData.total }}</div>
                  <div class="text-body2 font-weight-bold text-grey">รายงานทั้งหมด</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-green" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="success" class="mb-2">mdi-check-circle</v-icon>
                  <div class="text-h4 font-weight-bold success--text mb-2">{{ summaryData.approved }}</div>
                  <div class="text-body2 font-weight-bold text-grey">อนุมัติแล้ว</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-warning" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="warning" class="mb-2">mdi-clock-alert</v-icon>
                  <div class="text-h4 font-weight-bold warning--text mb-2">{{ summaryData.pending }}</div>
                  <div class="text-body2 font-weight-bold text-grey">รอการอนุมัติ</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-red" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="error" class="mb-2">mdi-close-circle</v-icon>
                  <div class="text-h4 font-weight-bold error--text mb-2">{{ summaryData.rejected }}</div>
                  <div class="text-body2 font-weight-bold text-grey">ปฏิเสธ/ยกเลิก</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Charts Section -->
          <v-row class="mb-8">
            <v-col cols="12" lg="6">
              <v-card class="elevation-2" style="border-radius: 12px">
                <v-card-title class="pb-4">
                  <v-icon small class="mr-2">mdi-chart-pie</v-icon>
                  สัดส่วนสถานะรายงาน
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-6">
                  <div v-if="chartData.statusPie.length > 0">
                    <apexchart
                      type="pie"
                      :options="chartOptions.statusPie"
                      :series="chartData.statusPie"
                      height="350"
                    />
                  </div>
                  <div v-else class="text-center py-12 text-grey">
                    <v-icon size="48" class="mb-2">mdi-chart-box-outline</v-icon>
                    <p>ไม่มีข้อมูล</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" lg="6">
              <v-card class="elevation-2" style="border-radius: 12px">
                <v-card-title class="pb-4">
                  <v-icon small class="mr-2">mdi-chart-bar</v-icon>
                  จำนวนพนักงานตามสถานศึกษา (Top 10)
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-6">
                  <div v-if="chartData.employeeSeries[0] && chartData.employeeSeries[0].data.length > 0">
                    <apexchart
                      type="bar"
                      :options="chartOptions.employeeBar"
                      :series="chartData.employeeSeries"
                      height="350"
                    />
                  </div>
                  <div v-else class="text-center py-12 text-grey">
                    <v-icon size="48" class="mb-2">mdi-chart-box-outline</v-icon>
                    <p>ไม่มีข้อมูล</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Reports Table -->
          <v-card class="elevation-2" style="border-radius: 12px">
            <v-card-title class="pb-0">
              <v-icon small class="mr-2">mdi-format-list-bulleted</v-icon>
              รายการรายงานทั้งหมด
            </v-card-title>
            <v-divider class="my-4" />

            <v-card-text class="pa-4 pb-0">
              <v-row class="align-center mb-4">
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="tableFilters.search"
                    label="ค้นหาชื่อสถานศึกษา"
                    outlined
                    dense
                    rounded
                    prepend-icon="mdi-magnify"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn
                    color="success"
                    outlined
                    rounded
                    @click="exportApprovalData"
                    :loading="isExporting"
                    class="mt-1"
                  >
                    <v-icon small class="mr-1">mdi-file-excel</v-icon>
                    ส่งออก Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :headers="tableHeaders"
              :items="filteredReports"
              :loading="isLoading"
              :page.sync="tablePage"
              :items-per-page="itemsPerPage"
              :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
              class="elevation-0"
            >
              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="getStatusColor(item.status)"
                  text-color="white"
                  small
                  label
                  rounded
                >
                  {{ getStatusText(item.status) }}
                </v-chip>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon small color="primary">
                      <v-icon small>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item @click="viewReportDetails(item)">
                      <v-list-item-icon>
                        <v-icon small>mdi-eye</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>ดูรายละเอียด</v-list-item-title>
                    </v-list-item>

                    <v-divider />

                    <v-list-item
                      v-if="item.status === 'submitted'"
                      @click="checkingProcess(item)"
                    >
                      <v-list-item-icon>
                        <v-icon small color="warning">mdi-clock-check-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>ตรวจสอบ</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="item.status === 'submitted' || item.status === 'checking'"
                      @click="openApprovalDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon small color="success">mdi-check-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>อนุมัติ</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="item.status === 'submitted' || item.status === 'checking'"
                      @click="openRejectDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon small color="error">mdi-close-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>ปฏิเสธ</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="item.status === 'approved'"
                      @click="openCancelApprovalDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon small color="warning">mdi-trash-can</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>ยกเลิกการอนุมัติ</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:no-data>
                <div class="text-center py-8 text-grey">
                  <v-icon size="48" class="mb-2">mdi-folder-open-outline</v-icon>
                  <p>ไม่มีข้อมูลรายงาน</p>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>

        <!-- ======================== TAB 2: BUDGET STATISTICS ======================== -->
        <v-tab-item>
          <!-- Filter Section -->
          <v-card class="mb-6 elevation-2 mt-4" style="border-radius: 12px">
            <v-card-text class="pa-6">
              <h3 class="text-h6 font-weight-bold mb-4">
                <v-icon small class="mr-2">mdi-filter-variant</v-icon>
                ตัวกรองข้อมูล
              </h3>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="budgetFilters.report_year"
                    :items="yearOptions"
                    label="ปีการศึกษา"
                    outlined
                    dense
                    rounded
                    @change="loadBudgetData"
                    prepend-icon="mdi-calendar"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="budgetFilters.report_time"
                    :items="timeOptions"
                    label="ครั้งที่"
                    outlined
                    dense
                    rounded
                    @change="loadBudgetData"
                    prepend-icon="mdi-clock-outline"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn
                    color="primary"
                    block
                    rounded
                    @click="loadBudgetData"
                    :loading="isLoading"
                    height="40"
                    class="font-weight-bold"
                  >
                    <v-icon small class="mr-1">mdi-refresh</v-icon>
                    ค้นหา
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Budget Summary Cards -->
          <v-row class="mb-8">
            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-blue" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="primary" class="mb-2">mdi-cash-multiple</v-icon>
                  <div class="text-h6 font-weight-bold text-primary mb-2">{{ formatCurrency(budgetSummary.total_allocated) }}</div>
                  <div class="text-body2 font-weight-bold text-grey">งบประมาณจัดสรร</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-green" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="success" class="mb-2">mdi-check-circle</v-icon>
                  <div class="text-h6 font-weight-bold success--text mb-2">{{ formatCurrency(budgetSummary.total_disbursed) }}</div>
                  <div class="text-body2 font-weight-bold text-grey">เบิกจ่ายแล้ว</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100 gradient-card-warning" style="border-radius: 12px">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="warning" class="mb-2">mdi-cash</v-icon>
                  <div class="text-h6 font-weight-bold warning--text mb-2">{{ formatCurrency(budgetSummary.total_remaining) }}</div>
                  <div class="text-body2 font-weight-bold text-grey">คงเหลือ</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-card class="elevation-1 h-100" style="border-radius: 12px; background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border: 1px solid #ce93d8;">
                <v-card-text class="pa-6 text-center">
                  <v-icon size="48" color="secondary" class="mb-2">mdi-percent</v-icon>
                  <div class="text-h6 font-weight-bold secondary--text mb-2">{{ budgetSummary.overall_disburse_percentage }}%</div>
                  <div class="text-body2 font-weight-bold text-grey">อัตราเบิกจ่าย</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Budget Tabs -->
          <v-tabs v-model="budgetTab" background-color="transparent" color="primary">
            <v-tab>
              <v-icon small class="mr-2">mdi-chart-line</v-icon>
              สรุปข้อมูล
            </v-tab>
            <v-tab>
              <v-icon small class="mr-2">mdi-building</v-icon>
              วิเคราะห์สถานศึกษา
            </v-tab>
            <v-tab>
              <v-icon small class="mr-2">mdi-calendar-month</v-icon>
              แนวโน้มรายเดือน
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="budgetTab">
            <!-- Charts Tab -->
            <v-tab-item>
              <v-row class="mt-4">
                <v-col cols="12" lg="6">
                  <v-card class="elevation-2" style="border-radius: 12px">
                    <v-card-title class="pb-4">
                      <v-icon small class="mr-2">mdi-chart-pie</v-icon>
                      สัดส่วนการเบิกจ่าย
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="pa-6">
                      <div v-if="budgetSummary.total_allocated > 0">
                        <apexchart
                          type="pie"
                          :options="chartOptions.disbursementPie"
                          :series="[budgetSummary.total_disbursed, budgetSummary.total_remaining]"
                          height="350"
                        />
                      </div>
                      <div v-else class="text-center py-12 text-grey">
                        <v-icon size="48" class="mb-2">mdi-chart-box-outline</v-icon>
                        <p>ไม่มีข้อมูล</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-card class="elevation-2" style="border-radius: 12px">
                    <v-card-title class="pb-4">
                      <v-icon small class="mr-2">mdi-chart-line</v-icon>
                      แนวโน้มการเบิกจ่าย
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="pa-6">
                      <div v-if="chartData.trendData.length > 0">
                        <apexchart
                          type="line"
                          :options="chartOptions.trendLine"
                          :series="chartData.trendSeries"
                          height="350"
                        />
                      </div>
                      <div v-else class="text-center py-12 text-grey">
                        <v-icon size="48" class="mb-2">mdi-chart-box-outline</v-icon>
                        <p>ไม่มีข้อมูล</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- College Analysis Tab -->
            <v-tab-item>
              <v-card class="elevation-2 mt-4" style="border-radius: 12px">
                <v-card-title class="pb-4">
                  <v-icon small class="mr-2">mdi-building</v-icon>
                  วิเคราะห์งบประมาณตามสถานศึกษา
                </v-card-title>
                <v-divider />

                <v-card-text class="pa-4">
                  <v-row class="mb-4">
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="collegeFilter.search"
                        label="ค้นหาชื่อสถานศึกษา"
                        outlined
                        dense
                        rounded
                        prepend-icon="mdi-magnify"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-btn
                        color="success"
                        outlined
                        rounded
                        @click="exportBudgetData"
                        :loading="isExporting"
                        class="mt-1"
                      >
                        <v-icon small class="mr-1">mdi-file-excel</v-icon>
                        ส่งออก Excel
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="collegeTableHeaders"
                    :items="filteredCollegeData"
                    :loading="isLoading"
                    class="elevation-0"
                    :items-per-page="itemsPerPage"
                    :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
                  >
                    <template v-slot:item.disburse_percentage="{ item }">
                      <v-chip
                        :color="getPercentageColor(item.disburse_percentage)"
                        text-color="white"
                        label
                        small
                      >
                        {{ item.disburse_percentage }}%
                      </v-chip>
                    </template>

                    <template v-slot:item.allocated_budget="{ item }">
                      {{ formatCurrency(item.allocated_budget) }}
                    </template>

                    <template v-slot:item.disbursed_budget="{ item }">
                      {{ formatCurrency(item.disbursed_budget) }}
                    </template>

                    <template v-slot:item.remaining_budget="{ item }">
                      {{ formatCurrency(item.remaining_budget) }}
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Monthly Trend Tab -->
            <v-tab-item>
              <v-card class="elevation-2 mt-4" style="border-radius: 12px">
                <v-card-title class="pb-4">
                  <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                  แนวโน้มการเบิกจ่ายรายเดือน
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-4">
                  <v-data-table
                    :headers="monthlyTableHeaders"
                    :items="chartData.trendData"
                    :loading="isLoading"
                    class="elevation-0"
                  >
                    <template v-slot:item.month="{ item }">
                      {{ getMonthName(item.month) }}
                    </template>

                    <template v-slot:item.disburse_percentage="{ item }">
                      <v-chip
                        :color="getPercentageColor(item.disburse_percentage)"
                        text-color="white"
                        label
                        small
                      >
                        {{ item.disburse_percentage }}%
                      </v-chip>
                    </template>

                    <template v-slot:item.total_allocated="{ item }">
                      {{ formatCurrency(item.total_allocated) }}
                    </template>

                    <template v-slot:item.total_disbursed="{ item }">
                      {{ formatCurrency(item.total_disbursed) }}
                    </template>

                    <template v-slot:item.total_remaining="{ item }">
                      {{ formatCurrency(item.total_remaining) }}
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tab-item>
      </v-tabs-items>
    </v-container>

    <!-- Report Details Dialog -->
    <v-dialog v-model="showDetailsDialog" max-width="700px" persistent>
      <v-card class="elevation-8" style="border-radius: 12px">
        <v-toolbar dark color="primary" rounded>
          <v-btn icon dark @click="showDetailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>รายละเอียดรายงาน</v-toolbar-title>
          <v-spacer />
          <v-chip small text-color="white" :color="getStatusColor(selectedReport.status)" label>
            {{ getStatusText(selectedReport.status) }}
          </v-chip>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-6">
          <v-simple-table dense>
            <tbody>
              <tr>
                <td class="font-weight-bold text-right pr-4 w-40 py-2">สถานศึกษา:</td>
                <td class="py-2">{{ selectedReport.college_name }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-right pr-4 py-2">รหัส:</td>
                <td class="py-2">{{ selectedReport.college_code }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-right pr-4 py-2">ปีการศึกษา:</td>
                <td class="py-2">{{ selectedReport.report_year }}/{{ selectedReport.report_time }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-right pr-4 py-2">จำนวนพนักงาน:</td>
                <td class="py-2">{{ selectedReport.total_employees }} คน</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-right pr-4 py-2">ผู้อำนวยการ:</td>
                <td class="py-2">{{ selectedReport.director_name }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-right pr-4 py-2">ตำแหน่ง:</td>
                <td class="py-2">{{ selectedReport.director_title }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-right pr-4 py-2">วันที่รายงาน:</td>
                <td class="py-2">{{ formatDate(selectedReport.created_at) }}</td>
              </tr>
              <tr v-if="selectedReport.approved_date">
                <td class="font-weight-bold text-right pr-4 py-2">อนุมัติเมื่อ:</td>
                <td class="py-2">{{ formatDate(selectedReport.approved_date) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="showDetailsDialog = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approval Dialog -->
    <v-dialog v-model="showApprovalDialog" max-width="500px" persistent>
      <v-card class="elevation-8" style="border-radius: 12px">
        <v-toolbar dark color="success" rounded>
          <v-toolbar-title>ยืนยันการอนุมัติ</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="showApprovalDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6 mt-4">
          <p class="mb-4">
            ยืนยันการอนุมัติรายงานจาก
            <strong class="text-primary">{{ selectedReport.college_name }}</strong> หรือไม่?
          </p>

          <v-textarea
            v-model="approvalData.notes"
            label="หมายเหตุ (ไม่บังคับ)"
            outlined
            rounded
            dense
            rows="3"
            counter="500"
            maxlength="500"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showApprovalDialog = false">
            ยกเลิก
          </v-btn>
          <v-btn color="success" rounded @click="approveReport" :loading="isProcessing">
            <v-icon small class="mr-1">mdi-check-circle</v-icon>
            อนุมัติ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Rejection Dialog -->
    <v-dialog v-model="showRejectDialog" max-width="500px" persistent>
      <v-card class="elevation-8" style="border-radius: 12px">
        <v-toolbar dark color="error" rounded>
          <v-toolbar-title>ปฏิเสธรายงาน</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="showRejectDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6 mt-4">
          <p class="mb-4">
            ปฏิเสธรายงานจาก
            <strong class="text-error">{{ selectedReport.college_name }}</strong> หรือไม่?
          </p>

          <v-textarea
            v-model="rejectionData.reason"
            label="เหตุผลในการปฏิเสธ"
            outlined
            rounded
            dense
            rows="4"
            counter="500"
            maxlength="500"
            :rules="[v => !!v || 'ต้องระบุเหตุผล']"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showRejectDialog = false">
            ยกเลิก
          </v-btn>
          <v-btn color="error" rounded @click="rejectReport" :loading="isProcessing" :disabled="!rejectionData.reason">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            ปฏิเสธ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cancel Approval Dialog -->
    <v-dialog v-model="showCancelApprovalDialog" max-width="500px" persistent>
      <v-card class="elevation-8" style="border-radius: 12px">
        <v-toolbar dark color="warning" rounded>
          <v-toolbar-title>ยกเลิกการอนุมัติ</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="showCancelApprovalDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6 mt-4">
          <p class="mb-4">
            ยกเลิกการอนุมัติรายงานจาก
            <strong class="warning--text">{{ selectedReport.college_name }}</strong> หรือไม่?
          </p>

          <v-textarea
            v-model="cancellationData.reason"
            label="เหตุผลในการยกเลิก"
            outlined
            rounded
            dense
            rows="4"
            counter="500"
            maxlength="500"
            :rules="[v => !!v || 'ต้องระบุเหตุผล']"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showCancelApprovalDialog = false">
            ยกเลิก
          </v-btn>
          <v-btn color="warning" rounded @click="cancelApproval" :loading="isProcessing" :disabled="!cancellationData.reason">
            <v-icon small class="mr-1">mdi-trash-can</v-icon>
            ยกเลิกการอนุมัติ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" :color="snackbar.color" top right rounded>
      <v-icon small class="mr-2">
        {{ snackbar.color === "success" ? "mdi-check-circle" : "mdi-alert-circle" }}
      </v-icon>
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import Manpowermenubar_govem from "../../../components/admin/manpowermenubar_govem.vue";

export default {
  components: { Manpowermenubar_govem },

  data() {
    return {
      ApiKey: "HRvec2021",
      mainTab: 0,
      budgetTab: 0,
      isLoading: false,
      isProcessing: false,
      isExporting: false,

      // Approval Filters
      filters: {
        report_year: null,
        report_time: null,
        status: null
      },

      tableFilters: {
        search: ""
      },

      // Budget Filters
      budgetFilters: {
        report_year: null,
        report_time: null
      },

      collegeFilter: {
        search: ""
      },

      // Data
      reports: [],
      topInstitutions: [],
      collegeData: [],
      
      summaryData: {
        total: 0,
        approved: 0,
        pending: 0,
        checking: 0,
        rejected: 0,
        cancelled: 0,
        draft: 0,
        total_employees: 0
      },

      budgetSummary: {
        total_reports: 0,
        total_colleges: 0,
        total_allocated: 0,
        total_disbursed: 0,
        total_remaining: 0,
        overall_disburse_percentage: 0
      },

      // Options
      yearOptions: [],
      timeOptions: [
        { text: "ครั้งที่ 1", value: 1 },
        { text: "ครั้งที่ 2", value: 2 },
        { text: "ครั้งที่ 3", value: 3 }
      ],
      statusOptions: [
        { text: "ร่าง", value: "draft" },
        { text: "รอการอนุมัติ", value: "submitted" },
        { text: "ดำเนินการตรวจสอบ", value: "checking" },
        { text: "อนุมัติแล้ว", value: "approved" },
        { text: "ปฏิเสธ", value: "rejected" },
        { text: "ยกเลิก", value: "cancelled" }
      ],
      monthOptions: [
        { text: "มกราคม", value: 1 },
        { text: "กุมภาพันธ์", value: 2 },
        { text: "มีนาคม", value: 3 },
        { text: "เมษายน", value: 4 },
        { text: "พฤษภาคม", value: 5 },
        { text: "มิถุนายน", value: 6 },
        { text: "กรกฎาคม", value: 7 },
        { text: "สิงหาคม", value: 8 },
        { text: "กันยายน", value: 9 },
        { text: "ตุลาคม", value: 10 },
        { text: "พฤศจิกายน", value: 11 },
        { text: "ธันวาคม", value: 12 }
      ],

      // Dialog
      showDetailsDialog: false,
      showApprovalDialog: false,
      showRejectDialog: false,
      showCancelApprovalDialog: false,

      selectedReport: {
        college_name: "",
        college_code: "",
        report_year: "",
        report_time: "",
        status: "draft",
        created_at: null,
        total_employees: 0,
        director_name: "",
        director_title: ""
      },

      approvalData: {
        notes: ""
      },

      rejectionData: {
        reason: ""
      },

      cancellationData: {
        reason: ""
      },

      // Table
      tablePage: 1,
      itemsPerPage: 25,
      tableHeaders: [
        { text: "รหัส", value: "college_code", width: "10%" },
        { text: "ชื่อสถานศึกษา", value: "college_name", width: "25%" },
        { text: "ครั้งที่", value: "report_time", width: "8%" },
        { text: "ปี", value: "report_year", width: "8%" },
        { text: "จำนวนพนักงาน", value: "total_employees", width: "12%" },
        { text: "สถานะ", value: "status", width: "12%" },
        { text: "วันที่", value: "created_at", width: "15%" },
        { text: "", value: "actions", width: "10%", sortable: false }
      ],

      collegeTableHeaders: [
        { text: "รหัส", value: "college_code", width: "10%" },
        { text: "ชื่อสถานศึกษา", value: "college_name", width: "28%" },
        { text: "รายงาน", value: "total_reports", width: "10%" },
        { text: "งบจัดสรร", value: "allocated_budget", width: "15%" },
        { text: "เบิกจ่าย", value: "disbursed_budget", width: "15%" },
        { text: "คงเหลือ", value: "remaining_budget", width: "12%" },
        { text: "อัตรา %", value: "disburse_percentage", width: "10%" }
      ],

      monthlyTableHeaders: [
        { text: "เดือน", value: "month", width: "15%" },
        { text: "รายงาน", value: "total_reports", width: "12%" },
        { text: "งบจัดสรร", value: "total_allocated", width: "18%" },
        { text: "เบิกจ่าย", value: "total_disbursed", width: "18%" },
        { text: "คงเหลือ", value: "total_remaining", width: "15%" },
        { text: "อัตรา %", value: "disburse_percentage", width: "12%" }
      ],

      // Chart data
      chartData: {
        statusPie: [],
        employeeSeries: [{ name: "จำนวนพนักงาน", data: [] }],
        trendData: [],
        trendSeries: []
      },

      // Chart options
      chartOptions: {},

      // Snackbar
      snackbar: {
        show: false,
        message: "",
        color: "success",
        timeout: 3000
      },
      period_college: [],

    };
  },

  computed: {
    filteredReports() {
      return this.reports.filter(report => {
        const matchSearch =
          !this.tableFilters.search ||
          (report.college_name &&
            report.college_name
              .toLowerCase()
              .includes(this.tableFilters.search.toLowerCase())) ||
          (report.college_code &&
            report.college_code
              .toLowerCase()
              .includes(this.tableFilters.search.toLowerCase()));
        return matchSearch;
      });
    },

    filteredCollegeData() {
      return this.collegeData.filter(college => {
        const matchSearch =
          !this.collegeFilter.search ||
          (college.college_name &&
            college.college_name
              .toLowerCase()
              .includes(this.collegeFilter.search.toLowerCase())) ||
          (college.college_code &&
            college.college_code
              .toLowerCase()
              .includes(this.collegeFilter.search.toLowerCase()));
        return matchSearch;
      });
    }
  },

  async mounted() {
    await this.period_collegeQuery();

    this.initializeYears();
    this.initializeCharts();
    this.filters.report_year = new Date().getFullYear() + 543;
    this.budgetFilters.report_year = new Date().getFullYear() + 543;
    await this.loadApprovalData();
    await this.loadBudgetData();
  },

  methods: {
        async period_collegeQuery() {
      try {
        let result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "80104"
        });
        this.period_college = result.data;
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูลช่วงการศึกษา", "error");
      }
    },


    initializeYears() {
      const currentYear = new Date().getFullYear() + 543;
      this.yearOptions = [];
      for (let i = 0; i <= 5; i++) {
        this.yearOptions.push(currentYear - i);
      }
    },

    initializeCharts() {
      this.chartOptions = {
        statusPie: {
          chart: { type: "pie", toolbar: { show: true } },
          labels: ["ร่าง", "รอการอนุมัติ", "ตรวจสอบ", "อนุมัติแล้ว", "ปฏิเสธ", "ยกเลิก"],
          colors: ["#9E9E9E", "#2196F3", "#FF9800", "#4CAF50", "#F44336", "#FF5722"],
          legend: { position: "bottom" }
        },

        employeeBar: {
          chart: { type: "bar", toolbar: { show: true } },
          plotOptions: {
            bar: {
              horizontal: true,
              columnWidth: "75%"
            }
          },
          xaxis: {
            title: { text: "จำนวนพนักงาน" }
          },
          colors: ["#2196F3"],
          dataLabels: { enabled: true }
        },

        disbursementPie: {
          chart: { type: "pie", toolbar: { show: true } },
          labels: ["เบิกจ่ายแล้ว", "คงเหลือ"],
          colors: ["#4CAF50", "#FFC107"],
          legend: { position: "bottom" }
        },

        trendLine: {
          chart: { type: "line", toolbar: { show: true } },
          stroke: { curve: "smooth", width: 2 },
          colors: ["#2196F3", "#F44336"],
          legend: { position: "top" }
        }
      };
    },

    // ========== APPROVAL METHODS ==========
    async loadApprovalData() {
      this.isLoading = true;
      try {
        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "get_reports",
            report_year: this.period_college.period_college_year || this.filters.report_year,
            report_time: this.period_college.period_college_times || this.filters.report_time,
            status: this.filters.status
          }
        );

        if (response.data && response.data.status) {
          this.reports = response.data.data || [];
          this.topInstitutions = response.data.topInstitutions || [];
          this.updateApprovalSummary();
          this.updateApprovalCharts();
        }
      } catch (error) {
        console.error("Error loading approval data:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูล", "error");
      } finally {
        this.isLoading = false;
      }
    },

    updateApprovalSummary() {
      const response = this.$http.post(
        "government_employee_report_complete.php",
        {
          ApiKey: this.ApiKey,
          action: "get_summary",
          report_year: this.period_college.period_college_year || this.filters.report_year,
          report_time: this.period_college.period_college_times || this.filters.report_time
        }
      );

      response.then(res => {
        if (res.data && res.data.status) {
          this.summaryData = res.data.data;
        }
      }).catch(error => {
        console.error("Error loading summary:", error);
      });
    },

    updateApprovalCharts() {
      const draftCount =
        this.summaryData.total -
        this.summaryData.approved -
        this.summaryData.pending -
        this.summaryData.checking -
        this.summaryData.rejected;

      this.chartData.statusPie = [
        draftCount,
        this.summaryData.pending,
        this.summaryData.checking,
        this.summaryData.approved,
        this.summaryData.rejected,
        this.summaryData.cancelled
      ];

      if (this.topInstitutions && this.topInstitutions.length > 0) {
        this.chartData.employeeSeries = [
          {
            name: "จำนวนพนักงาน",
            data: this.topInstitutions.map(inst => ({
              x: inst.college_name || "ไม่ระบุ",
              y: inst.total_employees || 0
            }))
          }
        ];
      }
    },

    viewReportDetails(report) {
      this.selectedReport = { ...report };
      this.showDetailsDialog = true;
    },

    openApprovalDialog(report) {
      this.selectedReport = { ...report };
      this.approvalData.notes = "";
      this.showApprovalDialog = true;
    },

    openRejectDialog(report) {
      this.selectedReport = { ...report };
      this.rejectionData.reason = "";
      this.showRejectDialog = true;
    },

    openCancelApprovalDialog(report) {
      this.selectedReport = { ...report };
      this.cancellationData.reason = "";
      this.showCancelApprovalDialog = true;
    },

    async approveReport() {
      this.isProcessing = true;
      try {
        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "approve_report",
            report_id: this.selectedReport.id,
            notes: this.approvalData.notes
          }
        );

        if (response.data && response.data.status) {
          this.showSnackbar("อนุมัติรายงานสำเร็จ", "success");
          this.showApprovalDialog = false;
          await this.loadApprovalData();
        } else {
          this.showSnackbar(response.data.message || "เกิดข้อผิดพลาด", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.isProcessing = false;
      }
    },

    async rejectReport() {
      this.isProcessing = true;
      try {
        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "reject_report",
            report_id: this.selectedReport.id,
            rejection_reason: this.rejectionData.reason
          }
        );

        if (response.data && response.data.status) {
          this.showSnackbar("ปฏิเสธรายงานสำเร็จ", "success");
          this.showRejectDialog = false;
          await this.loadApprovalData();
        } else {
          this.showSnackbar(response.data.message || "เกิดข้อผิดพลาด", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.isProcessing = false;
      }
    },

    async cancelApproval() {
      this.isProcessing = true;
      try {
        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "cancel_approval",
            report_id: this.selectedReport.id,
            cancellation_reason: this.cancellationData.reason
          }
        );

        if (response.data && response.data.status) {
          this.showSnackbar("ยกเลิกการอนุมัติสำเร็จ", "success");
          this.showCancelApprovalDialog = false;
          await this.loadApprovalData();
        } else {
          this.showSnackbar(response.data.message || "เกิดข้อผิดพลาด", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.isProcessing = false;
      }
    },

    async checkingProcess(item) {
      this.isProcessing = true;
      try {
        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "checking",
            report_id: item.id
          }
        );

        if (response.data && response.data.status) {
          this.showSnackbar("เปลี่ยนสถานะเป็นกำลังตรวจสอบเรียบร้อย", "success");
          await this.loadApprovalData();
        } else {
          this.showSnackbar(response.data.message || "เกิดข้อผิดพลาด", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.isProcessing = false;
      }
    },

    // ========== BUDGET METHODS ==========
    async loadBudgetData() {
      this.isLoading = true;
      try {
        // Load summary
        const summaryResponse = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "get_budget_summary",
            report_year: this.period_college.period_college_year || this.budgetFilters.report_year,
            report_time: this.period_college.period_college_times || this.budgetFilters.report_time
          }
        );

        if (summaryResponse.data && summaryResponse.data.status) {
          this.budgetSummary = summaryResponse.data.data;
        }

        // Load college data
        const collegeResponse = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "get_college_budget_analysis",
            report_year: this.budgetFilters.report_year,
            report_time: this.budgetFilters.report_time
          }
        );

        if (collegeResponse.data && collegeResponse.data.status) {
          this.collegeData = collegeResponse.data.data || [];
        }

        // Load trend data
        const trendResponse = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "get_budget_disbursement_trend",
            report_year: this.budgetFilters.report_year,
            report_time: this.budgetFilters.report_time
          }
        );

        if (trendResponse.data && trendResponse.data.status) {
          this.chartData.trendData = trendResponse.data.data || [];
          this.updateBudgetCharts();
        }
      } catch (error) {
        console.error("Error loading budget data:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูล", "error");
      } finally {
        this.isLoading = false;
      }
    },

    updateBudgetCharts() {
      if (this.chartData.trendData.length > 0) {
        this.chartData.trendSeries = [
          {
            name: "เบิกจ่าย",
            data: this.chartData.trendData.map(d => d.total_disbursed)
          },
          {
            name: "จัดสรร",
            data: this.chartData.trendData.map(d => d.total_allocated)
          }
        ];
      }
    },

    // ========== EXPORT METHODS ==========
    async exportApprovalData() {
      try {
        this.isExporting = true;

        const XLSX = await import("xlsx");

        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "get_export_data_approval",
            report_year: this.period_college.period_college_year || this.filters.report_year,
            report_time: this.period_college.period_college_times || this.filters.report_time,
            status: this.filters.status
          }
        );

        if (!response.data || !response.data.status) {
          this.showSnackbar("ไม่สามารถดึงข้อมูลสำหรับส่งออก", "error");
          return;
        }

        const exportData = response.data.data.map((item, index) => ({
          ลำดับที่: index + 1,
          รหัส: item.college_code || "-",
          "ชื่อสถานศึกษา": item.college_name || "-",
          "ปีการศึกษา": item.report_year || "-",
          "ครั้งที่": item.report_time || "-",
          "จำนวนพนักงาน": item.total_employees || 0,
          "ผู้อำนวยการ": item.director_name || "-",
          "ตำแหน่ง": item.director_title || "-",
          "สถานะ": this.getStatusText(item.status) || "-",
          "วันที่รายงาน": this.formatDate(item.created_at) || "-",
          "อนุมัติเมื่อ": item.approved_date ? this.formatDate(item.approved_date) : "-"
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "รายงานการอนุมัติ");

        const date = new Date();
        const year = date.getFullYear() + 543;
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const filename = `รายงานการอนุมัติ_${year}-${month}-${day}.xlsx`;

        XLSX.writeFile(wb, filename);
        this.showSnackbar("ส่งออก Excel สำเร็จ", "success");
      } catch (error) {
        console.error("Error exporting:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการส่งออก", "error");
      } finally {
        this.isExporting = false;
      }
    },

    async exportBudgetData() {
      try {
        this.isExporting = true;

        const XLSX = await import("xlsx");

        const response = await this.$http.post(
          "government_employee_report_complete.php",
          {
            ApiKey: this.ApiKey,
            action: "get_export_data_budget",
            report_year: this.budgetFilters.report_year,
            report_time: this.budgetFilters.report_time
          }
        );

        if (!response.data || !response.data.status) {
          this.showSnackbar("ไม่สามารถดึงข้อมูลสำหรับส่งออก", "error");
          return;
        }

        const exportData = response.data.data.map((item, index) => ({
          ลำดับที่: index + 1,
          รหัส: item.college_code || "-",
          "ชื่อสถานศึกษา": item.college_name || "-",
          "ปีการศึกษา": item.report_year || "-",
          "ครั้งที่": item.report_time || "-",
          "เดือน": this.getMonthName(item.month) || "-",
          "งบจัดสรร": item.allocated_budget || 0,
          "เบิกจ่าย": item.disbursed_budget || 0,
          "คงเหลือ": item.remaining_budget || 0,
          "อัตรา %": item.disburse_percentage || 0,
          "หมายเหตุ": item.notes || "-"
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "สถิติการเบิกจ่าย");

        const date = new Date();
        const year = date.getFullYear() + 543;
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const filename = `สถิติการเบิกจ่าย_${year}-${month}-${day}.xlsx`;

        XLSX.writeFile(wb, filename);
        this.showSnackbar("ส่งออก Excel สำเร็จ", "success");
      } catch (error) {
        console.error("Error exporting:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการส่งออก", "error");
      } finally {
        this.isExporting = false;
      }
    },

    // ========== UTILITY METHODS ==========
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    },

    formatCurrency(value) {
      if (!value) return "฿ 0.00";
      return "฿ " + parseFloat(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    getStatusColor(status) {
      const colors = {
        draft: "grey",
        checking: "warning",
        submitted: "info",
        approved: "success",
        rejected: "error",
        cancelled: "warning"
      };
      return colors[status] || "grey";
    },

    getStatusText(status) {
      const texts = {
        draft: "ร่าง",
        submitted: "รอการอนุมัติ",
        checking: "กำลังตรวจสอบ",
        approved: "อนุมัติแล้ว",
        rejected: "ปฏิเสธ",
        cancelled: "ยกเลิก"
      };
      return texts[status] || status;
    },

    getMonthName(month) {
      const monthOption = this.monthOptions.find(m => m.value === month);
      return monthOption ? monthOption.text : "-";
    },

    getPercentageColor(percentage) {
      if (percentage >= 80) return "success";
      if (percentage >= 60) return "info";
      if (percentage >= 40) return "warning";
      return "error";
    },

    showSnackbar(message, color = "success") {
      this.snackbar = { show: true, message, color, timeout: 3000 };
    }
  }
};
</script>

<style scoped>
.gradient-card-blue {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border: 1px solid #90caf9;
}

.gradient-card-green {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border: 1px solid #81c784;
}

.gradient-card-warning {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border: 1px solid #ffb74d;
}

.gradient-card-red {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  border: 1px solid #ef5350;
}

.h-100 {
  height: 100%;
}

.w-40 {
  width: 40%;
}

::v-deep .v-data-table {
  background-color: transparent;
}

::v-deep .v-data-table th {
  background-color: rgba(33, 150, 243, 0.08) !important;
  font-weight: 600;
  color: #1976d2;
}

::v-deep .v-data-table tbody tr:hover {
  background-color: rgba(33, 150, 243, 0.04) !important;
}

::v-deep .v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

::v-deep .v-card:hover {
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1) !important;
}
</style>